import React from "react";
import { Layout, Typography } from "antd";
import { useIsMobile } from "../../hooks/useIsMobile";

const { Footer } = Layout;

interface AppFooterProps {
  collapsed: boolean;
  SIDEBAR_WIDTH: number;
}

const AppFooter: React.FC<AppFooterProps> = ({ collapsed, SIDEBAR_WIDTH }) => {
  const isMobile = useIsMobile();

  return (
    <Footer
      style={{
        position: "fixed",
        bottom: isMobile ? 8 : 16,
        left: isMobile ? 8 : (collapsed ? 80 : SIDEBAR_WIDTH) + 32,
        right: isMobile ? 8 : 16,
        height: isMobile ? 48 : 60,
        backgroundColor: "#ffffff",
        borderTop: "1px solid #f0f0f0",
        borderRadius: isMobile ? 10 : 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "0 12px" : "0 24px",
        transition: "all 0.3s ease",
      }}
    >
      <Typography.Text
        style={{
          color: "#595959",
          fontSize: isMobile ? 12 : 13,
          fontWeight: 500,
          textAlign: "center",
          whiteSpace: "nowrap",
        }}
      >
        © {new Date().getFullYear()} NeoView — v0.1.0
      </Typography.Text>
    </Footer>
  );
};

export default AppFooter;
